import React from "react";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

//core-ui
import {
  CTableRow, CTableDataCell, CTable,
  CTableBody, CTableHead, CTableHeaderCell
} from "@coreui/react";

import { useHttp } from "../hooks/useHttp";
import { useQuery } from "@tanstack/react-query";
import LoadingCenter from "../components/LoadingCenter";

const ContactEmails = () => {
  const request = useHttp();
  const { data, isLoading } = useQuery({ queryKey: ["emails"], queryFn: () => request({ url: "/emailform", method: "GET" }) });

  console.log(data);

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <span>E-mails de contato</span>
      </div>
      <div className="dashboard__container">
        {isLoading && <LoadingCenter />}

        {!isLoading && <CTable striped>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell scope="col">
                <span className="text-color">Datas</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">Dados do contato</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col" style={{ width: "300px" }}>
                <span className="text-color">Mensagem</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">Admin</span>
              </CTableHeaderCell>
              {/* <CTableHeaderCell scope="col" style={{ width: "140px" }}>
                <span className="text-color">Qtd/mensagens</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col" style={{ width: "140px" }}>
                <span className="text-color">Qtd/ligações</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">Usadão</span>
              </CTableHeaderCell> */}
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {data?.data?.map((form, index) => {
              return (
                <CTableRow key={index}>
                  <CTableDataCell className="align-middle">
                    <p className="text-color p-none">
                      <strong>Criado em:</strong> {moment(form.createAt).format("ll")}
                    </p>
                    <p className="text-color p-none">
                      <strong>Lida em:</strong> {moment(form.readAt).format("ll")}
                    </p>
                  </CTableDataCell>
                  <CTableDataCell className="align-middle">
                    <p className="text-color p-none">
                      <strong>Nome:</strong> {form.name ? form.name : "Sem nome"}
                    </p>
                    <p className="text-color p-none">
                      <strong>E-mail:</strong> {form.email ? form.email : "Sem e-mail"}
                    </p>
                    <p className="text-color p-none">
                      <strong>Fone:</strong> {form.phone ? form.phone : "Sem Telefone"}
                    </p>
                  </CTableDataCell>
                  <CTableDataCell className="align-middle" style={{ width: "300px" }}>
                    <p className="text-color p-none">
                      {form.message ? form.message : "Sem mensagem"}
                    </p>
                  </CTableDataCell>
                  <CTableDataCell className="align-middle">
                    <p className="text-color p-none">
                      {form.admin_pegou ? form.admin_pegou : "Admin não identificado"}
                    </p>
                  </CTableDataCell>
                  {/* <CTableDataCell className="align-middle" style={{ width: "140px" }}>
                    <p className="text-color p-none">
                      {form.qtdMessages ? form.qtdMessages : 0}
                    </p>
                  </CTableDataCell>
                  <CTableDataCell className="align-middle" style={{ width: "140px" }}>
                    <p className="text-color p-none">
                      {form.qtdCall ? form.qtdCall : 0}
                    </p>
                  </CTableDataCell>
                  <CTableDataCell className="align-middle">
                    <p className="text-color p-none">
                      {form.usadao_id ? <img src={require("../imgs/icon-colored.png")} /> : ""}
                    </p>
                  </CTableDataCell> */}
                </CTableRow>
              );
            })}
          </CTableBody>
        </CTable>}
      </div>
    </div>
  );
}

export default ContactEmails;
